module.exports = __webpack_public_path__ + "src/assets/img/bg.ee2fc053.jpg";